module.exports = __webpack_public_path__ + "static/media/hero.6b44aa80.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero.webp
// module id = 334
// module chunks = 0